import React from 'react';
import type { Marks } from 'rc-slider';

import { Mark } from './styled.ts';

export const generateMarks = (min: number, max: number, step: number): Marks => {
  const range = max - min;
  const stepCount = step ? range / step : range;
  const markCount = stepCount + 1;

  return Array.from({ length: markCount }).reduce<Marks>((acc, _, index) => {
    const markValue = min + (index * range) / (markCount - 1);
    acc[markValue] = React.createElement(Mark);
    return acc;
  }, {});
};
